module.exports = __webpack_public_path__ + "static/media/insp_cat_1.d22d7b4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/insp_cat_1.jpg
// module id = 1849
// module chunks = 0